import AccuVision from "../../images/AccuVision_Dash2.png";
import BlockPortal from "../../images/BlockPortal2.png";
import Capstone from "../../images/Capstone.png";
import Architecture from "../../images/arch2.jpg";
import SpotDocAI from "../../images/SpotDocAI.png";
import Portlio from "../../images/Portlio.png";

const projects = [
  {
    id: "portlio",
    title: "Portlio",
    subtitle: "Investment Portfolio Analytics Platform",
    award: "📊 Full-Stack FinTech Application",
    awardType: "purple",
    link: "https://portlio-tracker.netlify.app/",
    description:
      "A comprehensive investment management platform for tracking multi-currency stock and fund portfolios. Provides real-time portfolio analytics, performance insights, sector allocation analysis, and interactive dashboards with secure Firebase authentication.",
    techStack: [
      "React.js",
      "Vite",
      "Firebase",
      "Firestore",
      "Recharts",
      "JavaScript",
      "CSS",
      "Lucide React"
    ],
    image: Portlio,
    imageAlt: "Portlio Investment Dashboard",
    reverse: true,
  },
  {
    id: "spotdocai",
    title: "SpotDocAI",
    subtitle: "Enterprise RAG & Document Intelligence Platform",
    award: "🚀 Full-Stack AI System",
    awardType: "purple",
    link: "https://github.com/DG-20/SpotDocAI",
    description:
      "SpotDocAI is a full-stack AI-powered platform for scalable document ingestion, semantic search, and natural language Q&A. Users can upload collections of documents and receive context-aware, citation-backed answers in real time.",
    techStack: ["C# .NET", "Next.js", "Kernel-Memory (RAG)", "Ollama (LLM)", "MinIO", "Postgres", "Redis Queue", "Docker"],
    image: SpotDocAI,
    imageAlt: "SpotDocAI Dashboard",
    reverse: false,
  },
  {
    id: "capstone",
    title: "Real-Time Weather Event Monitoring System",
    subtitle: "UCalgary Capstone Project for RBC",
    award: "🎓 RBC Capstone Project",
    awardType: "gold",
    link: "https://schulich.ucalgary.ca/sites/default/files/teams/4/2024%20Capstone/2024%20Capstone%20Projects/61925-49%20RealTime%20Weather%20Event%20Monitoring%20System.pdf",
    description:
      "Final-year capstone prototype for RBC that aggregates, processes, and visualizes real-time weather events. Achieved under 10-minute processing for thousands of events affecting millions of locations nationwide.",
    techStack: ["Python", "FastAPI", "Docker", "MongoDB", "Next.js", "Redis"],
    image: Capstone,
    imageAlt: "RBC Capstone Weather Dashboard",
    reverse: true,
  },
  {
    id: "blockportal",
    title: "BlockPortal",
    subtitle: "Decentralized Student Web3 Portal",
    award: "🏆 MakeUC Hackathon Winner (Best Blockchain)",
    awardType: "gold",
    link: "https://github.com/DG-20/MakeUC",
    description:
      "Blockchain-integrated student portal prototype offering secure, decentralized transactions. Recognized as “Best Blockchain Project Using Hedera” at MakeUC 2022 Hackathon.",
    techStack: ["Django", "Hedera Blockchain SDK", "MongoDB", "JavaScript", "PyMongo", "Python"],
    image: BlockPortal,
    imageAlt: "BlockPortal Interface",
    reverse: false,
  },
  {
    id: "accuvision",
    title: "AccuVision",
    subtitle: "Computer Vision Occupancy Tracking",
    award: "🏆 HackTogether 2021 (1st Place Winner)",
    awardType: "gold",
    link: "https://github.com/DG-20/HackTogether---AccuVision",
    description:
      "Real-time occupancy tracking using computer vision, providing a public dashboard to help limit Covid-19 spread. Won 1st place at HackTogether 2021.",
    techStack: ["Python", "OpenCV", "Pandas", "Dash & Plotly", "HTML & CSS", "Google Drive API"],
    image: AccuVision,
    imageAlt: "AccuVision Vision Dashboard",
    reverse: true,
  },
  {
    id: "reid",
    title: "Person Re-Identification Deep Learning Model",
    subtitle: "Explainable AI Attribute Classification",
    award: "📄 Published IEEE Paper (SSCI 2021)",
    awardType: "cyan",
    link: "https://github.com/th-truong/explainable-id-reid",
    paperLink: "https://ieeexplore.ieee.org/document/9660071",
    citationText: "Towards Explainable Person Re-Identification",
    description:
      "Practical deep-learning model for person re-identification that emphasizes explainability and transparency while maintaining high performance.",
    techStack: ["PyTorch", "Python", "Pandas", "Scikit-Learn", "NumPy", "PIL"],
    image: Architecture,
    imageAlt: "Person Re-ID Model Architecture",
    reverse: false,
  },
];

export default projects;